import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AUTH_SERVER_URL } from '../../config';
import { FieldOfPartner, Partner } from '../../eorder/models/eorder';
import { PaginatedResult } from '../models/paginated-result';

const AUTH_PARTNER = `${ AUTH_SERVER_URL }/v1/partners`;

@Injectable({ providedIn: 'root' })
export class CustomerMasterService {
	constructor(
		private readonly http: HttpClient,
	) {}

	getPartners(
		fields?: FieldOfPartner[],
		filter?: string,
		service?: string,
	) {
		const dataUrl = new URL(AUTH_PARTNER);
		const params = dataUrl.searchParams;
		if (fields) {
			params.append('fields', fields.join(','));
		}
		if (filter) {
			params.append('filter', filter);
		}
		if (service) {
			params.append('service', service);
		}
		return this.http.get<PaginatedResult<Partner>>(dataUrl.toString());
	}

	getPartnersShipments(partnerNumbers: string[], service?: string) {
		const dataUrl = new URL(`${ AUTH_PARTNER }/shipments`);
		const params = dataUrl.searchParams;
		if (partnerNumbers.length > 0) {
			params.append('partnerNumbers', partnerNumbers.join(','));
		}
		if (service) {
			params.append('service', service);
		}
		return this.http.get<Record<string, { tmode: string; incoterm: string }[]>>(dataUrl.toString());
	}
}
